import h from "../../../../_virtual/get.js";
import l from "../../../../_virtual/isNil.js";
import P from "../../../../_virtual/isString.js";
import D from "../../../../_virtual/isFunction.js";
import j from "../../../../_virtual/isObject.js";
import { Children as p, isValidElement as w } from "react";
import { r as B } from "../../../../_virtual/index5.js";
import { isNumber as b } from "./DataUtils.js";
import { shallowEqual as d } from "./ShallowEqual.js";
import { SVGElementPropKeys as G, EventKeys as F, FilteredElementKeyMap as s } from "./types.js";
var _ = ["children"], R = ["children"];
function E(o, e) {
  if (o == null) return {};
  var r = L(o, e), t, n;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(o);
    for (n = 0; n < i.length; n++)
      t = i[n], !(e.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(o, t) && (r[t] = o[t]);
  }
  return r;
}
function L(o, e) {
  if (o == null) return {};
  var r = {};
  for (var t in o)
    if (Object.prototype.hasOwnProperty.call(o, t)) {
      if (e.indexOf(t) >= 0) continue;
      r[t] = o[t];
    }
  return r;
}
function m(o) {
  "@babel/helpers - typeof";
  return m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, m(o);
}
var O = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, y = function(e) {
  return typeof e == "string" ? e : e ? e.displayName || e.name || "Component" : "";
}, S = null, c = null, v = function o(e) {
  if (e === S && Array.isArray(c))
    return c;
  var r = [];
  return p.forEach(e, function(t) {
    l(t) || (B.isFragment(t) ? r = r.concat(o(t.props.children)) : r.push(t));
  }), c = r, S = e, r;
};
function I(o, e) {
  var r = [], t = [];
  return Array.isArray(e) ? t = e.map(function(n) {
    return y(n);
  }) : t = [y(e)], v(o).forEach(function(n) {
    var i = h(n, "type.displayName") || h(n, "type.name");
    t.indexOf(i) !== -1 && r.push(n);
  }), r;
}
function Y(o, e) {
  var r = I(o, e);
  return r && r[0];
}
var Z = function(e) {
  if (!e || !e.props)
    return !1;
  var r = e.props, t = r.width, n = r.height;
  return !(!b(t) || t <= 0 || !b(n) || n <= 0);
}, V = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], q = function(e) {
  return e && e.type && P(e.type) && V.indexOf(e.type) >= 0;
}, C = function(e) {
  return e && m(e) === "object" && "clipDot" in e;
}, N = function(e, r, t, n) {
  var i, a = (i = s === null || s === void 0 ? void 0 : s[n]) !== null && i !== void 0 ? i : [];
  return !D(e) && (n && a.includes(r) || G.includes(r)) || t && F.includes(r);
}, ee = function(e, r, t) {
  if (!e || typeof e == "function" || typeof e == "boolean")
    return null;
  var n = e;
  if (/* @__PURE__ */ w(e) && (n = e.props), !j(n))
    return null;
  var i = {};
  return Object.keys(n).forEach(function(a) {
    var f;
    N((f = n) === null || f === void 0 ? void 0 : f[a], a, r, t) && (i[a] = n[a]);
  }), i;
}, W = function o(e, r) {
  if (e === r)
    return !0;
  var t = p.count(e);
  if (t !== p.count(r))
    return !1;
  if (t === 0)
    return !0;
  if (t === 1)
    return A(Array.isArray(e) ? e[0] : e, Array.isArray(r) ? r[0] : r);
  for (var n = 0; n < t; n++) {
    var i = e[n], a = r[n];
    if (Array.isArray(i) || Array.isArray(a)) {
      if (!o(i, a))
        return !1;
    } else if (!A(i, a))
      return !1;
  }
  return !0;
}, A = function(e, r) {
  if (l(e) && l(r))
    return !0;
  if (!l(e) && !l(r)) {
    var t = e.props || {}, n = t.children, i = E(t, _), a = r.props || {}, f = a.children, u = E(a, R);
    return n && f ? d(i, u) && W(n, f) : !n && !f ? d(i, u) : !1;
  }
  return !1;
}, re = function(e, r) {
  var t = [], n = {};
  return v(e).forEach(function(i, a) {
    if (q(i))
      t.push(i);
    else if (i) {
      var f = y(i.type), u = r[f] || {}, g = u.handler, M = u.once;
      if (g && (!M || !n[f])) {
        var T = g(i, f, a);
        t.push(T), n[f] = !0;
      }
    }
  }), t;
}, te = function(e) {
  var r = e && e.type;
  return r && O[r] ? O[r] : null;
}, ne = function(e, r) {
  return v(r).indexOf(e);
};
export {
  ee as filterProps,
  I as findAllByType,
  Y as findChildByType,
  y as getDisplayName,
  te as getReactEventByType,
  C as hasClipDot,
  W as isChildrenEqual,
  A as isSingleChildEqual,
  N as isValidSpreadableProp,
  ne as parseChildIndex,
  re as renderByOrder,
  v as toArray,
  Z as validateWidthHeight
};
